import { enableProdMode}                                               from '@angular/core';
import { platformBrowserDynamic }                                      from '@angular/platform-browser-dynamic';

import { environment }                                                 from './environments/environment';

import { loadTranslations } from '@angular/localize';
import { getTranslations } from '@soluling/angular';
import * as Sentry from '@sentry/angular';
import '@angular/localize/init';

if (environment.production) {
    enableProdMode();
}

if (environment.sentryEnabled) {
    console.debug('SENTRY ENABLED');
    Sentry.init({
        dsn: environment.sentryDSN,
        integrations: [
            // Registers and configures the Tracing integration,
            // which automatically instruments your application to monitor its
            // performance, including custom Angular routing instrumentation
            new Sentry.BrowserTracing({
                routingInstrumentation: Sentry.routingInstrumentation,
            }),
            new Sentry.Replay({
                maskAllText: false,
                blockAllMedia: false,
            }),

        ],
        ignoreErrors: ['<title>401 Unauthorized</title>', '<title>403 Forbidden</title>'],

        // Set tracesSampleRate to 1.0 to capture 100%
        // of transactions for performance monitoring.
        // We recommend adjusting this value in production
        tracesSampleRate: environment.sentryTracesSampleRate,

        // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
        tracePropagationTargets: [environment.api],
        // Session Replay
        replaysSessionSampleRate: environment.replaysSessionSampleRate,
        // If we're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
        replaysOnErrorSampleRate: 1.0,

        environment: environment.sentryEnvironment,
    });
} else {
    console.debug('SENTRY DISABLED');
}

getTranslations('assets/i18n', true, false, false, environment.default_locale, <string>localStorage.getItem('__localeId'))
    .then(translations => {
        if (translations) {
            loadTranslations(translations);
        }
        import('./app/app.module').then(module => {
            platformBrowserDynamic().bootstrapModule(module.AppModule)
                .catch(err => console.error(err));
        });
    });
